module.exports = __webpack_public_path__ + "img/picnic_inner_2.2909a723.jpg";